<template>
    <span :class="classObj">
        <input
            v-disabled-change
            @focus="addFocusClass()"
            @blur="removeFocusClass()"
            @disabled-change="onDisabledChange($event)"
            :autocomplete="$props.autocomplete"
            :id="$props.id"
            :name="$props.name"
            :value="$props.value"
            :required="$props.required"
            class="shared-input-radio__input"
            type="radio"
        />
        <span class="shared-input-radio__checked-circle"></span>
    </span>
</template>

<script>
import { AttributeChangeDirective } from '../../directives/attribute-change';

export default {
    directives: {
        'disabled-change': AttributeChangeDirective('disabled', 'disabled-change'),
    },
    data() {
        return {
            focusRecieved: false,
            disabled: false,
        };
    },
    props: {
        autocomplete: {
            type: String,
            default: 'off',
        },
        error: {
            type: Boolean,
            default: false,
        },
        id: String,
        name: String,
        value: String,
        required: Boolean,
    },
    methods: {
        addFocusClass() {
            this.focusRecieved = true;
        },
        removeFocusClass() {
            this.focusRecieved = false;
        },
        onDisabledChange({ target }) {
            this.disabled = target.disabled;
            // console.log(this.id, target.disabled);
        },
    },
    computed: {
        classObj() {
            return {
                'shared-input-radio': true,
                'shared-input-radio_error': this.$props.error,
                'shared-input-radio_focus': this.focusRecieved,
                'shared-input-radio_disabled': this.disabled,
            };
        },
    },
};
</script>
